var $b31a762e5ce5c75b$exports = {};
$b31a762e5ce5c75b$exports = {
    "more": `Dal\u{161}\xed polo\u{17E}ky`
};


export {$b31a762e5ce5c75b$exports as default};
//# sourceMappingURL=cs-CZ.mjs.map
